"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AclCategoryActionMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const acl_categories_entity_1 = require("./acl-categories.entity");
const acl_actions_entity_1 = require("./acl-actions.entity");
let AclCategoryActionMap = class AclCategoryActionMap {
    constructor(id, aclCategory, aclAction, createdBy, updatedBy) {
        this.id = id;
        this.aclCategory = aclCategory;
        this.aclAction = aclAction;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.AclCategoryActionMap = AclCategoryActionMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], AclCategoryActionMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => acl_categories_entity_1.AclCategory, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: "acl_category_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof acl_categories_entity_1.AclCategory !== "undefined" && acl_categories_entity_1.AclCategory) === "function" ? _c : Object)
], AclCategoryActionMap.prototype, "aclCategory", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => acl_actions_entity_1.AclAction, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: "acl_action_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof acl_actions_entity_1.AclAction !== "undefined" && acl_actions_entity_1.AclAction) === "function" ? _d : Object)
], AclCategoryActionMap.prototype, "aclAction", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], AclCategoryActionMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], AclCategoryActionMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], AclCategoryActionMap.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], AclCategoryActionMap.prototype, "updatedBy", void 0);
exports.AclCategoryActionMap = AclCategoryActionMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("acl_category_action_map"),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_a = typeof acl_categories_entity_1.AclCategory !== "undefined" && acl_categories_entity_1.AclCategory) === "function" ? _a : Object, typeof (_b = typeof acl_actions_entity_1.AclAction !== "undefined" && acl_actions_entity_1.AclAction) === "function" ? _b : Object, String, String])
], AclCategoryActionMap);
